import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'textSubstring'})
export class TextSubstring implements PipeTransform {
  transform(value: string, number: number): string {
    if (!value) return value;
    return value.length > number ? `${value.substring(0, number)}..` : value;
  }
}